export default __webpack_public_path__ + "static/media/banks.3fd92c01.png";